module.exports = __webpack_public_path__ + "9097d6a6ffb2d8b3fac5b03456048139.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Mission/components/CloudGradientSection/images/img_mission_cloud02.svg
// module id = 1267
// module chunks = 7